import client from "../client/client";

class LanguageService {
	get(cancelToken) {
		return client.get("/languages", { config: { cancelToken } });
	}
}

export default new LanguageService();
